import React from 'react';
import { motion } from 'framer-motion';
import { CalendarDaysIcon, CalendarRangeIcon, CalendarCheckIcon, MapPinnedIcon, PlaneIcon, LandmarkIcon, BriefcaseIcon, HeartIcon, UsersIcon, UserCheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const SERVICES = [{
  icon: CalendarDaysIcon,
  title: 'Sewa Mobil Harian',
  desc: 'Fleksibel untuk kebutuhan singkat harian Anda.'
}, {
  icon: CalendarRangeIcon,
  title: 'Sewa Mobil Bulanan',
  desc: 'Solusi hemat untuk pemakaian jangka menengah.'
}, {
  icon: CalendarCheckIcon,
  title: 'Sewa Mobil Tahunan',
  desc: 'Kontrak tahunan dengan harga terbaik.'
}, {
  icon: MapPinnedIcon,
  title: 'City Tour',
  desc: 'Jelajahi Garut dengan nyaman dan berkelas.'
}, {
  icon: PlaneIcon,
  title: 'Jemput & Antar Bandara',
  desc: 'Tepat waktu, aman sampai tujuan.'
}, {
  icon: LandmarkIcon,
  title: 'Wisata Religi',
  desc: 'Perjalanan ziarah yang tenang & nyaman.'
}, {
  icon: BriefcaseIcon,
  title: 'Perjalanan Dinas',
  desc: 'Profesional untuk kebutuhan korporat.'
}, {
  icon: HeartIcon,
  title: 'Wedding Car',
  desc: 'Mobil mewah untuk hari bahagia Anda.'
}, {
  icon: UsersIcon,
  title: 'Event & Keluarga',
  desc: 'Muat lebih banyak untuk momen bersama.'
}, {
  icon: UserCheckIcon,
  title: 'Driver Profesional',
  desc: 'Berpengalaman, ramah, dan terpercaya.'
}];
export function Services() {
  return <section id="layanan" className="relative bg-ink py-24" data-id="element-168" data-mp="3q0gsncrhsf1x">
      <div className="mx-auto max-w-7xl px-5" data-id="element-169" data-mp="3q18evwz790fj">
        <SectionHeading eyebrow="Layanan Kami" title={<>Beragam Layanan <span className="text-gold-gradient" data-id="element-171" data-mp="3g29fl50bqh57">Transportasi</span></>} subtitle="Kami siap melayani berbagai kebutuhan perjalanan Anda dengan armada premium dan pelayanan terbaik." data-id="element-170" data-mp="3u2k8edl725t0" />

        <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5" data-id="element-172" data-mp="24n40t2mx4s58">
          {SERVICES.map((s, i) => {
          const Icon = s.icon;
          return <motion.div key={s.title} initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.5,
            delay: i % 5 * 0.08
          }} className="group relative overflow-hidden rounded-2xl border border-white/5 bg-ink-card p-6 transition-all duration-300 hover:border-gold/40 hover:-translate-y-1" data-id="element-173" data-mp="1pk2w15zn0dsa" data-mpi={i}>
                <div className="absolute -right-8 -top-8 h-24 w-24 rounded-full bg-gold/5 blur-2xl transition-opacity duration-300 group-hover:opacity-100 opacity-0" data-id="element-174" data-mp="16ri5hv7eukrn" />
                <div className="mb-4 grid h-12 w-12 place-items-center rounded-xl gold-border bg-ink text-gold transition-colors group-hover:bg-gold group-hover:text-ink" data-id="element-175" data-mp="xtpq6r1ovd49">
                  <Icon className="h-6 w-6" data-id="element-176" data-mp="2s7h6g9eiwv8o" />
                </div>
                <h3 className="font-display text-lg font-semibold text-white" data-id="element-177" data-mp="2s4lb8su28knx">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-white/55" data-id="element-178" data-mp="2n5rsolzx23gw">{s.desc}</p>
              </motion.div>;
        })}
        </div>

        <p className="mt-8 text-center text-sm italic text-white/45" data-id="element-179" data-mp="2zpoth20kcl0p">
          …dan berbagai kebutuhan transportasi lainnya.
        </p>
      </div>
    </section>;
}